import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from 'src/app/services/admin.service';
import { BlogService } from 'src/app/services/blog.service';
import { GLOBAL } from 'src/app/services/GLOBAL';

declare var iziToast;
declare var jQuery:any;
declare var $:any;

@Component({
  selector: 'app-edit-blog',
  templateUrl: './edit-blog.component.html',
})
export class EditBlogComponent implements OnInit {

  @ViewChild('topicInputRef') topicInputRef: ElementRef;


  public blog : any = {
    title : '',
    text1: '',
    text2: '',
    quiz: [],
    tags: [] as { name: string }[]
  };

  availableTags: { name: string }[] = [
    { name: 'Tag1' },
    { name: 'Tag2' },
    { name: 'Tag3' }
  ]; // Aquí cargarás los tags preexistentes desde tu base de datos

  // Tags seleccionados por el usuario
  selectedTag: { title: string, _id: string } | null = null; // Usa null para mostrar el placeholder
  selectedTags: { title: string, _id: string }[] = [];

  public file1 : File = undefined;
  public file2 : File = undefined;
  public file3 : File = undefined;
  //public imgSelect : any | ArrayBuffer = 'assets/img/01.jpg';
  public token;
  public load_btn = false;
  public previewImage1: string | ArrayBuffer | null = 'assets/images/about-main.jpg'; // Imagen de muestra inicial 1
  public previewImage2: string | ArrayBuffer | null = 'assets/images/blog/1.jpg'; // Imagen de muestra inicial 2
  public previewImage3: string | ArrayBuffer | null = 'assets/images/blog/2.jpg'; // Imagen de muestra inicial 3

  topicInput: string = '';
  newTag: string = '';

  public config_global : any = {};
  public id;
  public url;

  public croppedImage1: any = '';//ng-image-cropper
  public croppedImage2: any = '';//ng-image-cropper
  public croppedImage3: any = '';//ng-image-cropper

  imageChangedEvent1: any = ''; //ng-image-cropper
  imageChangedEvent2: any = ''; //ng-image-cropper
  imageChangedEvent3: any = ''; //ng-image-cropper
  imageChangedEvent: any = ''; //ng-image-cropper

  public updateImage1 = false;
  public updateImage2 = false;
  public updateImage3 = false;


  constructor(
    private _adminService : AdminService,
    private _blogService : BlogService,
    private _router : Router,
    private _route : ActivatedRoute,
  ) {
    this.token = this._adminService.getToken();
    this._adminService.obtener_config_publico().subscribe({
      next: (response)=>{ this.config_global = response.data}
    });
    this.url = GLOBAL.url;

  }

  ngOnInit(): void {
    this._route.params.subscribe(
      params=>{
        this.id = params['id'];
        this._blogService.obtener_blog_admin(this.id,this.token).subscribe(
          response=>{
            if(response == undefined){
              this.blog = undefined;
            }else{
              this.blog = response.data;
              console.log(this.blog);              
              if (this.blog.image2 != null) {
                this.previewImage1 = this.blog.image1;  
              }
              if (this.blog.image2 != null) {
                this.previewImage2 = this.blog.image2;
              }
              if (this.blog.image3 != null) {
                this.previewImage3 = this.blog.image3;
              }
            }
          }
        ),
        error=>{
          console.log(error);
        }
      }
    )
  }

  actualizar(actualizarForm){
    if(actualizarForm.valid){
      this.load_btn = true;
      if (this.file1 != undefined) { this.blog.image1 = this.croppedImage1 };
      if (this.file2 != undefined) { this.blog.image2 = this.croppedImage2 };
      if (this.file3 != undefined) { this.blog.image3 = this.croppedImage3 };
      
      this._blogService.actualizar_blog_admin(this.blog,this.id,this.token).subscribe(
        response=>{          
          iziToast.show({message: 'Se actualizó correctamente el blog.',title: 'SUCCESS',titleColor: '#1DC74C',color: '#FFF',class: 'text-success',position: 'topRight',});
          this.load_btn = false;
          this._router.navigate(['/blogs/index-blog']);
        },
        error=>{
          console.log(error);
          this.load_btn = false;
        }
      )

    }else{
      iziToast.show({message: 'Debe llenar todos los campos del formulario para registrar el blog',title: 'ERROR',titleColor: '#FF0000',color: '#FFF',class: 'text-danger',position: 'topRight',});
      this.load_btn = false;
      $('#input-portada').text('Seleccionar imagen');
    }
  }

  //************************TOPICS******************* */

  handleEnterKey(event: KeyboardEvent) {
    event.preventDefault();
    const inputValue = this.topicInputRef.nativeElement.value;
    if (inputValue && inputValue.trim()) {
        this.addQuizTopic(inputValue.trim());
    }
  }

  addQuizTopic(topic: string) {
    this.blog.quiz.push(topic);
    this.topicInputRef.nativeElement.value = ''; // Limpiar el campo de entrada
    console.log("this.blog.quiz",this.blog.quiz);
  }

  removeQuizTopic(topic: string) {
    this.blog.quiz = this.blog.quiz.filter(t => t !== topic);
  }


  //******************TAGS*********************** */
  addTag() {
    if (this.selectedTag && !this.selectedTags.some(tag => tag._id === this.selectedTag!._id)) {
        this.selectedTags.push(this.selectedTag);
        this.blog.tags.push(this.selectedTag); // Agregar a this.blog.tags
        this.selectedTag = null; // Limpiar la selección después de agregar
        console.log("this.selectedTags",this.selectedTags);
    }
  }

  removeTag(tag: { title: string, _id: string }) {
      this.selectedTags = this.selectedTags.filter(t => t._id !== tag._id);
      this.blog.tags = this.blog.tags.filter(t => t._id !== tag._id); // Eliminar de this.blog.tags
  }

  //***********************IMAGES********************* */
  // Manejo del cambio de archivo
  fileChangeEvent(event: any, previewImageName: string, fileVarName: string, imageChangedEventName: string, imageChangedEventName2: string): void {
    let file_aux;
    if (event.target.files && event.target.files[0]) {
      file_aux = <File>event.target.files[0];
    } else {
      this.showErrorMessage('No hay una imagen de envío');
      this.resetImage(previewImageName, fileVarName);
      return;
    }
    if (['image/png', 'image/webp', 'image/jpg', 'image/gif', 'image/jpeg'].includes(file_aux.type)) {
      const reader = new FileReader();
      reader.onload = e => {
        this[previewImageName] = reader.result;
        console.log('Preview image updated:', this[previewImageName]);
      }
      reader.readAsDataURL(file_aux);

      // Almacena el archivo
      this[fileVarName] = file_aux;
      console.log(imageChangedEventName);
      this[imageChangedEventName] = event; // Establece el evento para el recorte
      console.log(this.imageChangedEvent1);
      this[imageChangedEventName2] = true;
    } else {
      this.showErrorMessage('El archivo debe ser una imagen');
      this.resetImage(previewImageName, fileVarName);
    }
  }


  showErrorMessage(message: string): void {
    iziToast.show({title: 'ERROR',titleColor: '#FF0000',color: '#FFF',class: 'text-danger',position: 'topRight',message: message,});
    $('#input-portada').text('Seleccionar imagen');
  }

  resetImage(previewImageName: string, fileVarName: string): void {
    this[previewImageName] = 'assets/images/about-main.jpg'; // Imagen de muestra inicial
    this[fileVarName] = undefined;
  }

  /************************NG-IMAGES-CROPPER********************* */

  onFileChange(event: any, imageName: string): void {
    console.log('Archivo seleccionado:', event);
    this[imageName + 'Event'] = event;
    this[imageName] = '';
  }

  onImageCropped(event: any, imageName: string): void {
    if (event.blob) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64data = reader.result as string; // Esto contiene la cadena base64

        // Asigna la cadena base64 a la variable correspondiente utilizando el nombre
        this[imageName] = base64data;
        console.log(`${imageName} recortada en base64:`, this[imageName]);
      };

      // Lee el blob de la imagen recortada
      reader.readAsDataURL(event.blob);
    } else {
      console.log('No se encontró el blob en el evento de recorte');
    }
  }



  onImageLoaded(): void {
    console.log('Imagen cargada correctamente');
  }

  onCropperReady(): void {
    console.log('Cropper listo');
  }

  onLoadImageFailed(): void {
    this.showErrorMessage('Error al cargar la imagen');
  }

  showSuccessMessage(message: string): void {
    console.log('Success:', message);
  }
}
